// Setup Profile question definitions (v8) — Food & Beverage MRP.
// User-facing name: "Setup Profile". Internal: "Operations Intelligence Profile".

export const TOOL_SUGGESTIONS = [
  "WooCommerce","Amazon","Faire","MRPeasy","Odoo","ShipStation","Airtable",
  "Notion","EDI / retailer portals","Paper records","Sage","Microsoft Dynamics",
  "Acumatica","SOS Inventory","Finale Inventory","Unleashed","Wherefour",
  "Craftybase","SafetyChain","TraceGains","FoodLogiQ","Co-packer portal",
];

export const QUESTIONS = [
  {
    id: "sku_range",
    type: "single",
    required: true,
    question: "How many SKUs do you currently manage?",
    options: ["1–5", "6–20", "21–50", "51–100", "100+", "Not sure"],
  },
  {
    id: "employee_count_range",
    type: "single",
    required: true,
    question: "How many people are on your team?",
    options: ["Just me", "2–5", "6–10", "11–25", "26–50", "51–100", "101+", "Not sure"],
  },
  {
    id: "annual_revenue_range",
    type: "single",
    required: true,
    question: "What is your approximate annual revenue?",
    options: [
      "Pre-revenue", "Under $100K", "$100K–$500K", "$500K–$1M", "$1M–$5M",
      "$5M–$10M", "$10M–$25M", "$25M+", "Prefer not to say",
    ],
  },
  {
    id: "production_frequency",
    type: "single",
    required: true,
    question: "How often do you run production or receive finished goods?",
    options: [
      "Daily production", "Multiple production runs per week", "Weekly production",
      "Biweekly production", "Monthly production", "Quarterly or seasonal production",
      "As needed / irregular schedule", "Pre-production / not producing yet",
    ],
  },
  {
    id: "current_operating_methods",
    type: "multi",
    required: true,
    question: "What do you rely on today to manage operations?",
    options: [
      "Spreadsheets", "QuickBooks", "Inventory software", "MRP / ERP software",
      "Paper records / whiteboards", "Co-packer reports", "Warehouse / 3PL reports",
      "Mostly manual / in someone’s head", "We do not have a clear system", "Other",
    ],
    otherField: "current_operating_methods_other",
  },
  {
    id: "current_tools",
    type: "multi",
    required: true,
    question: "Which tools are you using today?",
    options: [
      "Excel / Google Sheets", "QuickBooks Online", "QuickBooks Desktop", "Shopify",
      "Xero", "NetSuite", "Fishbowl", "Katana", "Cin7", "3PL / warehouse portal", "None",
    ],
    exclusive: ["None"],
    searchable: true,
  },
  {
    id: "operations_data_locations",
    type: "multi",
    required: true,
    question: "Where do you usually find the most accurate operations information?",
    options: [
      "Spreadsheet", "QuickBooks", "Inventory software", "MRP / ERP system",
      "Ecommerce platform", "Warehouse / 3PL system", "Co-packer reports",
      "Paper records", "Someone’s memory", "Nowhere reliable", "Other",
    ],
    otherField: "operations_data_locations_other",
  },
  {
    id: "problem_areas",
    type: "multi",
    required: true,
    question: "Which parts of your process create the most problems today?",
    options: [
      "Raw material inventory", "Packaging inventory", "Finished goods inventory",
      "Purchase planning", "Supplier costs", "Recipes / BOMs", "Production planning",
      "Production delays", "Batch records", "Lot tracking / traceability",
      "COGS / margins", "Sales order visibility", "Co-packer updates",
      "Inventory is tying up too much cash", "Buying too much, too early, or too late",
      "Nothing major", "Other",
    ],
    otherField: "problem_areas_other",
    exclusive: ["Nothing major"],
  },
  {
    id: "duplicated_workflows",
    type: "multi",
    required: true,
    question:
      "What information do you currently enter, update, or check in more than one place?",
    options: [
      "Inventory counts", "Purchase orders", "Ingredient or packaging costs",
      "Recipes / BOMs", "Production schedules", "Batch or lot records",
      "Finished goods inventory", "Sales orders", "COGS / margins",
      "Co-packer updates", "Nothing", "Not sure", "Other",
    ],
    otherField: "duplicated_workflows_other",
    exclusive: ["Nothing", "Not sure"],
  },
  {
    id: "decision_style",
    type: "single",
    required: true,
    question:
      "When you need to make an operations decision, what do you usually do first?",
    options: [
      "Check a spreadsheet", "Check software reports", "Ask someone on the team",
      "Ask a co-packer, warehouse, or supplier", "Look across several tools manually",
      "Estimate based on experience", "Wait until there is a problem", "Other",
    ],
    otherField: "decision_style_other",
  },
  {
    id: "desired_system_help",
    type: "multi",
    required: true,
    question: "What kind of help would be most useful from this system?",
    options: [
      "Tell me what to buy", "Tell me when to buy",
      "Show what I can produce with current inventory",
      "Warn me before I run out of materials",
      "Warn me when inventory is tying up too much cash",
      "Help calculate true product costs", "Flag margin or cost changes",
      "Keep recipes / BOMs organized", "Track lots, batches, and traceability",
      "Connect my current tools", "Reduce manual data entry",
      "Improve reporting and visibility", "Prioritize what needs attention first",
      "Other",
    ],
    otherField: "desired_system_help_other",
  },
  {
    id: "recommendation_control_preference",
    type: "single",
    required: true,
    question: "How much control would you want over system recommendations?",
    options: [
      "Just show me the data; I will decide",
      "Suggest actions, but let me approve everything",
      "Recommend actions and explain why",
      "Automatically flag problems and create tasks",
      "Automatically create purchase or production recommendations for review",
      "Not sure yet",
    ],
  },
];

export const INITIAL_ANSWERS = {
  sku_range: "",
  employee_count_range: "",
  annual_revenue_range: "",
  production_frequency: "",
  current_operating_methods: [],
  current_operating_methods_other: "",
  current_tools: [],
  operations_data_locations: [],
  operations_data_locations_other: "",
  problem_areas: [],
  problem_areas_other: "",
  duplicated_workflows: [],
  duplicated_workflows_other: "",
  decision_style: "",
  decision_style_other: "",
  desired_system_help: [],
  desired_system_help_other: "",
  recommendation_control_preference: "",
  additional_context: "",
};
